/**
 * Общие экраны состояний: загрузка, вход вне Telegram, ошибка авторизации,
 * отсутствие телефона, администратор в мини-аппе.
 *
 * Здесь важно то, что обычно забывают: «нет данных», «не хватает телефона» и
 * «ошибка» — три разных состояния с разным текстом и разным действием.
 *
 * Экраны курьера живут в `CourierApp` и соседних файлах.
 */
import { haptic } from '../tg';

export function Loading() {
  return (
    <main className="page">
      <p className="muted">Загрузка…</p>
    </main>
  );
}

/** Открыто вне Telegram: авторизоваться нечем, но вёрстка должна работать. */
export function NoTelegram() {
  return (
    <main className="page">
      <h1 className="h1">Арбуз</h1>
      <div className="card">
        <p style={{ margin: 0 }}>
          Приложение открывается внутри Telegram — через бота{' '}
          <a href="https://t.me/hochuarbuz_bot" style={{ color: 'var(--c-primary-text)' }}>
            @hochuarbuz_bot
          </a>
          .
        </p>
        <p className="muted" style={{ margin: 'var(--s-2) 0 0', fontSize: 'var(--fs-sm)' }}>
          В браузере доступен только просмотр вёрстки: подписанных данных для входа здесь нет.
        </p>
      </div>
    </main>
  );
}

export function AuthError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <main className="page">
      <h1 className="h1">Не удалось войти</h1>
      <div className="card">
        <p style={{ margin: 0 }}>{message}</p>
      </div>
      <button
        type="button"
        className="btn-primary"
        style={{ marginTop: 'var(--s-4)', width: '100%' }}
        onClick={() => {
          haptic('light');
          onRetry();
        }}
      >
        Повторить
      </button>
    </main>
  );
}

/** Администратор в мини-аппе не работает: его место — веб-панель. */
export function AdminInMiniApp() {
  return (
    <main className="page">
      <h1 className="h1">Админ-панель</h1>
      <div className="card">
        <p style={{ margin: 0 }}>
          Управление заказами доступно в веб-панели на компьютере — таблицы и карта зон
          не помещаются в экран телефона.
        </p>
        <p className="muted" style={{ margin: 'var(--s-2) 0 0', fontSize: 'var(--fs-sm)' }}>
          arbuz.my2.uz/admin
        </p>
      </div>
    </main>
  );
}
